<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="currentColor">
        <!-- Sense v-on="$listeners": a Vue 3 els listeners viatgen dins de
             $attrs i cauen sols sobre l'arrel unica (fallthrough), com a la
             resta d'icones. -->

        <path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z"/>
    </svg>
</template>